import { render, staticRenderFns } from "./vSearch.vue?vue&type=template&id=218998f2"
import script from "./vSearch.vue?vue&type=script&lang=js"
export * from "./vSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports